import {
    AutoComplete,
    Button,
    Card,
    Form,
    Input,
    List,
    Modal,
    Popconfirm,
    Radio,
    Select,
    Skeleton,
    Space,
    Spin,
    Typography,
  } from "antd";
  import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
  import { useEffect, useMemo, useRef, useState } from "react";
  import debounce from "lodash/debounce";
  import {
    AddEmployeeLicense,
    AddServerLicense,
    GetDeviceList,
    GetEmployeeDesignationCategoryById,
    GetEmployeeList,
    GetIPAddress,
    GetLicenseManagementSoftwares,
    GetSoftwareList,
    GetVersionBySoftwareId,
    axiosErrorMessages,
  } from "../../../API/api";
  import { enqueueSnackbar } from "notistack";
  import { DeleteOutlined } from "@ant-design/icons";
import AddSoftware from "../../license/components/AddSoftware";
import axios, { AxiosError } from "axios";
//   import AddSoftware from "./AddSoftware";
  interface Software {
    softwareName: string;
    version: string;
  }
  
  interface SoftwareId {
    softwareId: string;
    versionId: string;
  }
  
  interface Employee {
    employeeId: string;
    employeeAssets: EmployeeAsset[];
  }
  
  interface EmployeeAsset {
    deviceTypeId: number;
    assetTagId: string;
    os: number;
    osVersion: number[];
    assetSoftware: AssetSoftware[];
  }
  
  interface AssetSoftware {
    softwareId: number;
    versionId: number[];
  }
  interface AddEmployeeLicenseVersion {
    closeAddPopup: (data: any) => void;
  }
  const AddServer: React.FC<AddEmployeeLicenseVersion> = ({
    closeAddPopup,
  }) => {
    const isEdit:boolean = false
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [ipAddress,setIpAddress] = useState([])
    const [deviceList, setDeviceList] = useState([]);
    const [designationCategory, setDesignationCategory] = useState<string>("");
    const [addLicenseForm] = Form.useForm();
    const [softwareList, setSoftwareList] = useState([]);
    const [isAddSoftware, setIsAddSoftware] = useState<boolean>(false);
    const [isOpen, setIsopen] = useState<boolean>(true);
  const [hideAddDevice,setHideAddDevice] = useState<boolean>(false)
    const [selectedSoftwareList, setSelectedSoftwareList] = useState<Software[]>(
      []
    );
    const [selectedSoftwareListId, setSelectedSoftwareListId] = useState<any>([]);
    useEffect(() => {
      fetchIpList();
      GetOsList();
    }, []);
    const onAddNewSoftware = async () => {
      setIsAddSoftware(true);
    };
    const GetOsList = async () => {
      try {
        setIsLoading(true);
        const response = await GetLicenseManagementSoftwares();
  
        setSoftwareList(response.data);
        setIsLoading(false);
      } catch (error:any) {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // enqueueSnackbar("Error in fetching data", {
        //   variant: "error",
        //   anchorOrigin: {
        //     vertical: "top",
        //     horizontal: "right",
        //   },
        // });
        setIsLoading(false);
      }
    };
  
    const fetchIpList = async () => {
      try {
        setIsLoading(true);
        const response = await GetIPAddress();
        const newData = response.data.map((employee: any, index: number) => ({
          value: employee.ipAddressId,
          label: employee.ipAddress,
        }));
        setIpAddress(newData);
        setIsLoading(false);
      } catch (error: any) {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // enqueueSnackbar(error, {
        //   variant: "error",
        //   anchorOrigin: {
        //     vertical: "top",
        //     horizontal: "right",
        //   },
        // });
        setIsLoading(false);
      }
    };
  
    type FieldType = {
      employeeId?: string;
      device?: number;
      assetTagId: string;
    };
    const onClosePopup = () => {
      setIsopen(false);
      closeAddPopup(true);
    };
  
    const onSaveStatusHandler = (formData: any) => {
      if(formData.assetTagId.trim() && formData.serverName.trim()) {
         // Update the state with the new software entry
      if(selectedSoftwareListId.length === 0) {
        enqueueSnackbar("Select softwares for the server", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }else{
  const updatedState = {
    ...formData,
    ipAddress:"",
    assetSoftware:selectedSoftwareListId
   
  };

  AddServerLicense(updatedState)
    .then((response: any) => {
      enqueueSnackbar("Added Successfully", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      closeAddPopup(true);
    })
    .catch((error: any) => {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
     
    });

      }
   
      }else  enqueueSnackbar("Enter Mandatory Values", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
     
    };
  
    const onClose = () => setIsAddSoftware(false)
    const populateListData = (formData: any) => {
      setIsAddSoftware(false);
      const result: any = getSoftwareAndVersion(formData);
  
      // Use the spread operator to create a new array with the existing items and the new software
      // const updatedList: any = [...selectedSoftwareList, result];
      const updatedList: any = Array.from(
        new Set([...selectedSoftwareList, result])
      );
  
      const uniqueArray: Software[] = removeDuplicates([
        ...selectedSoftwareList,
        result,
      ]);
      setSelectedSoftwareListId(removeDuplicateIds([...selectedSoftwareListId, formData]))
  
    
      setSelectedSoftwareList(uniqueArray);
    };
    const removeDuplicateIds = (arr: any) => {
      const uniqueMap = new Map<string, SoftwareId>();
      arr.forEach((software: any) => {
        const key = `${software.softwareId}_${software.versionId}`;
        uniqueMap.set(key, software);
      });
      return Array.from(uniqueMap.values());
    };
    const removeDuplicates = (arr: any) => {
      const uniqueMap = new Map<string, Software>();
      arr.forEach((software: any) => {
        const key = `${software.softwareName}_${software.version}`;
        uniqueMap.set(key, software);
      });
      return Array.from(uniqueMap.values());
    };
  
    // Function to get software name and version based on softwareId and versionId
    const getSoftwareAndVersion = (formData: {
      softwareId: number;
      versionId: number;
    }) => {
      const software: any = softwareList.find(
        (item: any) => item.softwareId === formData.softwareId
      );
      if (software) {
        const version = software.versions.find(
          (v: any) => v.versionId === formData.versionId
        );
  
        if (version) {
          return {
            softwareName: software.softwareName,
            version: version.version,
            isOs: software.isOs

          };
        }
      }
  
      return undefined;
    };
    const removeItem = (rowData: any, index: number) => {
      const updatedSoftwareList = selectedSoftwareList.filter(
        (software: any) =>
          !(
            software.softwareName === rowData.softwareName &&
            software.version === rowData.version
          )
      );
      const newArray = selectedSoftwareListId.filter((_: any, index: number) => index !== index);

    setSelectedSoftwareListId(newArray);
      // setSelectedSoftwareListId(selectedSoftwareListId.splice(index, 1));
  
      setSelectedSoftwareList(updatedSoftwareList);
    };
    const filterOption = (
      input: string,
      option?: { label: string; value: number }
    ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    return (
      <>
        <Modal
          maskClosable={false}
          footer={null}
          title="Add License Provision"
          onCancel={onClosePopup}
          open={isOpen}
        >
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 12 }}
            style={{ maxWidth: 1000 }}
            onFinish={onSaveStatusHandler}
            autoComplete="off"
            form={addLicenseForm}
          >
            <Form.Item
              rules={[{ required: true, message: "Enter Name" }]}
              name="serverName"
            >
                <Input placeholder="Server Name"/>
              
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Enter Name" }]}
              name="ipAddressId"
            >
                <Select
                style={{ width: "100%" }}
                placeholder="Select IP"
                options={ipAddress}
                filterOption={filterOption}
                showSearch
              />
               </Form.Item>
               <Form.Item
              rules={[{ required: true, message: "Enter Asset Tag ID" }]}
              name="assetTagId"
            >
               <Input placeholder="Asset Tag ID"/>
               </Form.Item>
               <Button
                      type="text"
                        onClick={onAddNewSoftware}
                        icon={<PlusOutlined />}
                      >
                        Add Software
                      </Button>
  
                      <List
                        size="small"
                        className="demo-loadmore-list"
                        itemLayout="horizontal"
                        dataSource={selectedSoftwareList}
                        renderItem={(item: any, index) => (
                          <List.Item
                            actions={[
                              <>
                                <Popconfirm
                                  title="Do you want to remove the version?"
                                  onConfirm={() => removeItem(item, index)}
                                >
                                  <a>
                                    {" "}
                                    <DeleteOutlined />
                                  </a>
                                </Popconfirm>
                              </>,
                            ]}
                          >
                            <Skeleton
                              avatar
                              title={false}
                              loading={item.loading}
                              active
                            >
                              <List.Item.Meta title={item.softwareName} />
  
                              <List.Item.Meta title={item.version} />
                            </Skeleton>
                          </List.Item>
                        )}
                      />
     
  
            <Button className="pm-btn" type="primary" htmlType="submit">
              Save
            </Button>
          </Form>
        </Modal>
  
        {isAddSoftware && <AddSoftware softwareId={0} versionId={0} isEdit={isEdit} onClose={onClose} populateListData={populateListData} editSoftwareDetails={undefined} />}
      </>
    );
  };
  
  export default AddServer;
  